(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diagonal_bg"] && !window.DesignMode) return;
  try {
    
  const targets = document.querySelectorAll('.section-a-03 .anileft');

function checkVisibility() {
  const windowHeight = window.innerHeight;

  for (let i = 0; i < targets.length; i++) {
    const rect = targets[i].getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;

    if (scroll > offset - windowHeight + 80) {
      targets[i].classList.add('__shutter');
      const imgWrap = targets[i].querySelector('img');
      imgWrap.style.animation = 'anima_fadein 0.5s ease-out 0.7s 1 forwards';
    } else {
      targets[i].classList.remove('__shutter');
      const imgWrap = targets[i].querySelector('img');
      imgWrap.style.animation = '';
    }
  }
}

window.addEventListener('scroll', checkVisibility);
window.addEventListener('resize', checkVisibility);
window.addEventListener('DOMContentLoaded', checkVisibility);

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  } catch(e) { console.error(e); }
})();
})();
